module.exports = __webpack_public_path__ + "static/media/1f4a5.987b27ef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/emoji/1f4a5.svg
// module id = 644
// module chunks = 1